import { ListItemButton, ListItemIcon } from '@mui/material';
import EditSquareIcon from '@mui/icons-material/EditSquare';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import useModalParams from '@hooks/useModalParams';
import { LoadTender } from '@api/Trinium/Endpoints/EDI/types';
import { useMemo } from 'react';

export default function ViewModifyTenderListItem() {
	const gridApi = useGridApiContext();
	const selectedRowIds = useGridSelector(gridApi, gridRowSelectionIdsSelector);
	const { setSearchParameters } = useModalParams();

	const isDisabled = useMemo(() => {
		if (selectedRowIds.size !== 1) return true;

		const selectedRowId = selectedRowIds.keys().next().value;
		if (selectedRowId === undefined) return true;

		const selectedRow = gridApi.current.getRow<LoadTender>(selectedRowId);
		return !selectedRow || selectedRow.status !== 'Imported';
	}, [gridApi, selectedRowIds]);

	const handleBtnClick = () => {
		setSearchParameters({
			form: 'ediLoadTenderModal',
			formId: String(selectedRowIds.keys().next().value)
		});
	};

	return (
		<ListItemButton
			onClick={handleBtnClick}
			disabled={isDisabled}
		>
			<ListItemIcon sx={{ minWidth: '24px' }}>
				<EditSquareIcon
					fontSize='small'
					color='info'
				/>
			</ListItemIcon>
			View/Modify
		</ListItemButton>
	);
}
